/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Filterable_Select_No_ResultsInputs */

const en_forms_filterable_select_no_results = /** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results`)
};

const nl_forms_filterable_select_no_results = /** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten`)
};

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const de_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const es_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const fr_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const it_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const pt_br2_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const pl_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const hu_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/** @type {(inputs: Forms_Filterable_Select_No_ResultsInputs) => LocalizedString} */
const ro_forms_filterable_select_no_results = en_forms_filterable_select_no_results;

/**
* | output |
* | --- |
* | "No results" |
*
* @param {Forms_Filterable_Select_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const forms_filterable_select_no_results = /** @type {((inputs?: Forms_Filterable_Select_No_ResultsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Filterable_Select_No_ResultsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_filterable_select_no_results(inputs)
	if (locale === "de") return de_forms_filterable_select_no_results(inputs)
	if (locale === "es") return es_forms_filterable_select_no_results(inputs)
	if (locale === "fr") return fr_forms_filterable_select_no_results(inputs)
	if (locale === "nl") return nl_forms_filterable_select_no_results(inputs)
	if (locale === "it") return it_forms_filterable_select_no_results(inputs)
	if (locale === "pt-BR") return pt_br2_forms_filterable_select_no_results(inputs)
	if (locale === "pl") return pl_forms_filterable_select_no_results(inputs)
	if (locale === "hu") return hu_forms_filterable_select_no_results(inputs)
	return ro_forms_filterable_select_no_results(inputs)
});
export { forms_filterable_select_no_results as "forms.filterable_select.no_results" }